import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/lib/store'
import { Spinner } from '@/components/ui/primitives'

/**
 * Замена редиректов из mobile/app/_layout.tsx, где решение принималось
 * в useEffect по useSegments(). В вебе это делается декларативно на уровне
 * маршрутов — иначе на долю секунды показывается чужой экран.
 *
 * Ожидание восстановления сессии живёт здесь, а не в AuthProvider: решение
 * «впустить или отправить на вход» зависит от результата /auth/refresh,
 * а лендинг и юридические страницы от него не зависят вовсе и должны
 * открываться сразу.
 */

function SessionLoading() {
  return (
    <div className="flex h-dvh items-center justify-center bg-background">
      <Spinner size={36} className="text-primary" />
    </div>
  )
}

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, user } = useAuthStore()
  const location = useLocation()

  // Без этого вошедший пользователь, открывший ссылку на главу напрямую,
  // улетал бы на форму входа: сессия ещё не восстановлена
  if (isLoading) return <SessionLoading />

  if (!isAuthenticated) {
    // Запоминаем, куда пользователь шёл: после входа вернём его туда же
    return <Navigate to="/lk/auth/login" replace state={{ from: location.pathname }} />
  }

  // Онбординг обязателен: без имени и пола ИИ не может обращаться корректно,
  // а без даты рождения не включается режим разговора с несовершеннолетним
  const needsGreeting = !user?.name || !user?.sex || !user?.birthDate
  if (needsGreeting && location.pathname !== '/lk/greetings') {
    return <Navigate to="/lk/greetings" replace />
  }

  return <Outlet />
}

export function GuestRoute() {
  const { isAuthenticated, isLoading, user } = useAuthStore()

  // Иначе вошедшему на мгновение показывается форма входа,
  // прежде чем его перебросит в кабинет
  if (isLoading) return <SessionLoading />

  if (isAuthenticated) {
    const needsGreeting = !user?.name || !user?.sex || !user?.birthDate
    return <Navigate to={needsGreeting ? '/lk/greetings' : '/lk/bible'} replace />
  }

  return <Outlet />
}
